var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.452 0.987402C26.9204 0.987402 28.9291 3.02751 28.9291 5.53454V24.6255C28.9291 27.1326 26.9204 29.1718 24.452 29.1718H5.65518C4.45899 29.1718 3.3353 28.6986 2.4901 27.8401C1.6449 26.9817 1.17898 25.8395 1.17898 24.6246V5.53454C1.17898 3.02751 3.18677 0.987402 5.65518 0.987402H24.452ZM24.452 0.0795898H5.65518C2.68902 0.0795898 0.285156 2.52197 0.285156 5.53454V24.6255C0.285156 27.6381 2.68902 30.0796 5.65518 30.0796H24.452C27.4182 30.0796 29.8229 27.6381 29.8229 24.6255V5.53454C29.8229 2.52197 27.4182 0.0795898 24.452 0.0795898Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91539 11.7222H6.39844V23.4375H9.91539V11.7222Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23072 10.1505C9.16284 10.1505 9.91847 9.38303 9.91847 8.43632C9.91847 7.48962 9.16284 6.72217 8.23072 6.72217C7.29861 6.72217 6.54297 7.48962 6.54297 8.43632C6.54297 9.38303 7.29861 10.1505 8.23072 10.1505Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2962 12.5797C20.8896 11.4366 19.2717 11.3657 18.0057 11.794C16.7397 12.2223 15.6849 13.3124 15.6849 13.3124V11.7222H12.168V23.4375H15.6849V16.8656C15.6849 15.6031 16.6928 14.5794 17.9358 14.5794C19.1789 14.5794 20.1868 15.6031 20.1868 16.8656V23.4375H23.7037V16.8656C23.7037 15.5797 23.7037 13.7219 22.2971 12.5797H22.2962Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinIcon);
export default __webpack_public_path__ + "static/media/LinkdinIcon.8ffedf5574715aefe3fea7613ef9254a.svg";
export { ForwardRef as ReactComponent };